import { useMemo } from 'react';
import { useParams } from 'react-router';
import { GetVisitById } from 'woofwoof-api';
import { useCurrentVisitContext } from './useCurrentVisitContext';

export const useProfileVisit = (): GetVisitById | undefined => {
  const { patientId, profileId, visitId } = useParams<{
    patientId?: string;
    profileId?: string;
    visitId?: string;
  }>();
  const { data, getVisitByProfileId, getVisitById } = useCurrentVisitContext();

  const resolvedProfileId = patientId || profileId;

  return useMemo(() => {
    if (visitId) {
      return getVisitById(visitId);
    }
    return resolvedProfileId ? getVisitByProfileId(resolvedProfileId) : data;
  }, [visitId, resolvedProfileId, getVisitById, getVisitByProfileId, data]);
};
